import { render, staticRenderFns } from "./EditMappingDomain.vue?vue&type=template&id=8f70ac9a&scoped=true"
import script from "./EditMappingDomain.vue?vue&type=script&lang=js"
export * from "./EditMappingDomain.vue?vue&type=script&lang=js"
import style0 from "./EditMappingDomain.vue?vue&type=style&index=0&id=8f70ac9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f70ac9a",
  null
  
)

export default component.exports